import {useRef, useCallback, useEffect, useMemo, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import queryString from 'query-string';

type Props = {
  isModalOpen: boolean;
  callback: Function;
  customModalKey: string;
};

type TUrlParams = {
  slideUpModal?: boolean;
};

export function useModalBackNavigation({
  isModalOpen,
  callback,
  customModalKey = 'slideUpModal',
}: Props) {
  const history = useHistory();
  const location = useLocation();
  const firstRender = useRef(true);

  const locationSearch = location.search;
  const urlParams = useMemo(() => ({...queryString.parse(locationSearch)}), [locationSearch]);

  const customClose = useCallback(
    e => {
      e.stopPropagation();
      callback();
      history.goBack();
    },
    [history],
  );

  useEffect(() => {
    if (isModalOpen) {
      const reviewParams: TUrlParams = {...urlParams, [customModalKey]: true};
      history.push({
        ...location,
        search: queryString.stringify(reviewParams),
        state: {viewTransition: false, flushSync: false},
      });
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (isModalOpen && urlParams[customModalKey] !== 'true') {
      callback();
    }
  }, [urlParams[customModalKey]]);

  return {customClose};
}
